// BACK TO TOP BUTTON
// Get the button
let mybutton = document.getElementById("myBtn");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

// MEGA MENU
function bindMouseOverToMegaMenu(item) {
  if (item.hasAttribute("mouseover-bound")) return;
  let mouseOverTimeout;
  const megaMenuContent = item.querySelector(".mega-menu\_\_content");
  const mouseoverHandler = () => {
    item.open = true; // Properly open details
  };
  const mouseleaveHandler = () => {
    item.open = false; // Properly close details
  };
  item.addEventListener("mouseover", () => {
    clearTimeout(mouseOverTimeout);
    mouseOverTimeout = setTimeout(() => {
      item.open = true;
    }, 300); // 0.3-second delay
  });
  item.addEventListener("mouseleave", () => {
    clearTimeout(mouseOverTimeout);
    item.open = false;
  });
  item.setAttribute("mouseover-bound", true);
}
document.querySelectorAll(".header\_\_inline-menu details.mega-menu")
  .forEach(bindMouseOverToMegaMenu);

// FAQ FUNCTIONALITY
const EL = s => document.querySelectorAll(s),
ALL = (s, cb) => [...typeof s === 'string' ? EL(s) : s].forEach(cb);

function myFilter() {
  const val = this.value.trim(), // Get input value trimmed
    reg = new RegExp(val, 'ig'), // Construct case-insensitive global RegExp
    fil = this.getAttribute('data-filter'), // Get data attribute selector target "#myUL"
    CH = EL(fil)[0].children; // Get immediate children of UL (LI elements)
  ALL(CH, el => el.style.display = !val.length || reg.test(el.textContent) ? 'block':'none');
}

var acc = document.getElementsByClassName("faq-question");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {

  if( !this.classList.contains('active') ){
      closeAll();
    }

  this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
}

function openAll(){
    for (i = 0; i < acc.length; i++) {
      acc[i].classList.add("active");
        acc[i].nextElementSibling.style.maxHeight = acc[i].nextElementSibling.scrollHeight + "px";
    }
}

function closeAll(){
   for (i = 0; i < acc.length; i++) {
      acc[i].classList.remove("active");
        acc[i].nextElementSibling.style.maxHeight = null;
    }
}
ALL('[data-filter]', el => el.addEventListener('input', myFilter));


// Sidebar Collapsing code

document.addEventListener('DOMContentLoaded', function () {
  // Use page-specified defaults or fallback to closed
  const defaults = window.sidebarDefaults || { customer: false, help: false };

  document.querySelectorAll('.sidebar-header').forEach(function(header) {
    const name = header.dataset.sidebar;
    const content = header.nextElementSibling;
    const icon = header.querySelector('svg');
    const isOpen = defaults[name];

    if (isOpen) {
      content.classList.add('open');
      if (icon) icon.style.transform = 'rotate(180deg)';
    }

    header.addEventListener('click', function() {
      const nowOpen = content.classList.contains('open');
      content.classList.toggle('open');
      if (icon) icon.style.transform = nowOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  });
});